module.exports = __webpack_public_path__ + "img/mshoe8.39255a97.jpg";